import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_invoice_line_details_by_invoiceId_neService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { invoiceId: number, invoiceLineId?: number, top?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, LineNumber?: number, LineTotal?: number, Quantity?: number, TaxAmount?: number, UnitPrice?: number, BillingCode?: { Description?: string, Name?: string }, BillingRecords?: { BillingTaskId?: number, InvoiceLineId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.invoiceId)) {
      $missingRequiredInParams.push('\'invoiceId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { invoiceId: number, invoiceLineId?: number, top?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, LineNumber?: number, LineTotal?: number, Quantity?: number, TaxAmount?: number, UnitPrice?: number, BillingCode?: { Description?: string, Name?: string }, BillingRecords?: { BillingTaskId?: number, InvoiceLineId?: number }[] }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.invoiceId)) {
      $missingRequiredInParams.push('\'invoiceId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { invoiceId: number, invoiceLineId?: number, top?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, Description?: string, LineNumber?: number, LineTotal?: number, Quantity?: number, TaxAmount?: number, UnitPrice?: number, BillingCode?: { Description?: string, Name?: string }, BillingRecords?: { BillingTaskId?: number, InvoiceLineId?: number }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.invoiceId)) {
      $missingRequiredInParams.push('\'invoiceId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      invoiceId: number, invoiceLineId?: number, top?: number    }) {
        if(isNil($inParams.invoiceId)) {
          return true; 
        }
      return false;
    }
}
